var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactSupportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16.5,
    viewBox: "0 0 22 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-contacts-mail",
    "data-name": "Icon metro-contacts-mail",
    d: "M21.821,11.01v-.917l-2.75,1.833-2.75-1.833v.917l2.75,1.833Zm.917-4.583H4.4A1.833,1.833,0,0,0,2.571,8.26V21.093A1.833,1.833,0,0,0,4.4,22.927H22.737a1.825,1.825,0,0,0,1.824-1.833L24.571,8.26a1.833,1.833,0,0,0-1.833-1.833ZM9.9,9.177a2.75,2.75,0,1,1-2.75,2.75A2.752,2.752,0,0,1,9.9,9.177Zm5.5,11H4.4V19.26c0-1.833,3.667-2.842,5.5-2.842s5.5,1.008,5.5,2.842Zm7.333-5.5H15.4v-5.5h7.333Z",
    transform: "translate(-2.571 -6.427)",
    fill: "#fab700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupportIcon);
export default __webpack_public_path__ + "static/media/contactSupportIcon.f4397f9f97492755b932bdbbcb25af9e.svg";
export { ForwardRef as ReactComponent };